var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1029 5.54683C17.5128 6.50409 17.6132 7.56559 17.3899 8.58272C17.1666 9.59985 16.6308 10.5217 15.8575 11.2192C15.0843 11.9167 14.1122 12.3549 13.0776 12.4725C12.0429 12.5901 10.9973 12.3811 10.0872 11.875L5.70442 16.9531C5.35218 17.3053 4.87444 17.5032 4.3763 17.5032C3.87816 17.5032 3.40041 17.3053 3.04817 16.9531C2.69593 16.6008 2.49805 16.1231 2.49805 15.625C2.49805 15.1268 2.69593 14.6491 3.04817 14.2968L8.1263 9.91402C7.62012 9.00396 7.4112 7.9584 7.52879 6.9237C7.64638 5.88901 8.0846 4.91699 8.78208 4.14373C9.47957 3.37047 10.4014 2.83468 11.4185 2.61137C12.4357 2.38807 13.4972 2.48842 14.4544 2.89839L11.1732 6.17183L11.6185 8.38277L13.8294 8.82808L17.1029 5.54683Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/Wrench.3b1e16489ba72f5c97ebf9148a1f1744.svg";
export { ForwardRef as ReactComponent };